export const transferCommand = {
  updateTransfer: 'updateTransfer',
  // updateBuyersAndSellers: 'updateBuyersAndSellers'
};
